import axios from 'axios';
import { API_URL } from '../../../../modules/auth/core/_requests';
import { ShippingLineItem } from '../DeShippingTableWrapper';


export interface ApiResponse {
  success: boolean;
  data: {
    workflowId: number;
    orderId: string;
    lineItemsCount: number;
    lineItems: ShippingLineItem[];
  };
  error?: string;
  details?: string;
}



export interface StatusUpdateResult {
  success: boolean;
  message: string;
}

export const getLineItems = async (orderId: string): Promise<ApiResponse> => {
  try {
    const response = await axios.get<ApiResponse>(
      `${API_URL}/api/shopify-shipping/dashboard/line-items/${orderId}`
    );
    
    if (!response.data.success) {
      throw new Error(response.data.error || 'Failed to fetch line items');
    }
    
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.error || error.message || 'Failed to fetch line items');
    }
    throw error;
  }
};

export const acceptLineItem = async (workflowId: string): Promise<StatusUpdateResult> => {
  try {
    const response = await fetch(`${API_URL}/api/shopify-shipping/dashboard/order-status/accept`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        workflowId: workflowId.toString()
      }),
    });

    const result = await response.json();
    
    if (!response.ok) {
      return {
        success: false,
        message: result.message || `Failed to accept order: ${response.statusText}`
      };
    }

    return {
      success: true,
      message: result.message || 'Order accepted successfully'
    };
  } catch (error) {
    console.error('Failed to accept line item:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Unknown error accepting order'
    };
  }
};

export const declineLineItem = async (workflowId: string, reason: string): Promise<StatusUpdateResult> => {
  try {
    const response = await fetch(`${API_URL}/api/shopify-shipping/dashboard/order-status/decline`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        workflowId: workflowId.toString(),
        reason: reason
      }),
    });

    const result = await response.json();
    
    if (!response.ok) {
      return {
        success: false,
        message: result.message || `Failed to decline order: ${response.statusText}`
      };
    }

    return {
      success: true,
      message: result.message || 'Order declined successfully'
    };
  } catch (error) {
    console.error('Failed to decline line item:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Unknown error declining order'
    };
  }
};

export const reacceptLineItem = async (workflowId: string): Promise<StatusUpdateResult> => {
  try {
    const response = await fetch(`${API_URL}/api/shopify-shipping/dashboard/order-status/reaccept`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        workflowId: workflowId.toString()
      }),
    });

    const result = await response.json();
    
    if (!response.ok) {
      return {
        success: false,
        message: result.message || `Failed to reaccept order: ${response.statusText}`
      };
    }

    return {
      success: true,
      message: result.message || 'Order reaccepted successfully'
    };
  } catch (error) {
    console.error('Failed to reaccept line item:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Unknown error reaccepting order'
    };
  }
};